import { useMemo } from 'react';
import { CustomMultiSelectFilter, DateRangeFilter, FiltersBar } from '@britishcouncil/react-admin';
import { DisciplinaryActionDueReportFilterType } from 'store';
import { getLocationFilterDefinitions, LocationFilterDefinitions } from 'hooks';
import { useReportFiltersCascade, dateRangeValidate } from '../common';
import { WARNING_TYPE_OPTIONS } from 'const/warning-type/warningTypeOptions';

type DisciplinaryActionDueReportFilters = {
  date: DateRangeFilter;
  warningTypes: CustomMultiSelectFilter<number>;
} & LocationFilterDefinitions;

export type DisciplinaryActionDueReportFiltersBarProps = {
  initialFilterState: DisciplinaryActionDueReportFilterType;
  setFilterState: (filterState: DisciplinaryActionDueReportFilterType) => void;
};

export const DisciplinaryActionDueReportFiltersBar = ({
  initialFilterState,
  setFilterState,
}: DisciplinaryActionDueReportFiltersBarProps) => {
  const {
    filtersValues,
    errors,
    regionsOptions,
    countriesOptions,
    centresOptions,
    onFiltersApply,
    onFiltersChange,
  } = useReportFiltersCascade(initialFilterState, setFilterState, dateRangeValidate);

  const filtersDefinition = useMemo(
    (): DisciplinaryActionDueReportFilters => ({
      date: {
        type: 'daterange',
        label: 'Date range',
        isMain: true,
        datePickerOptions: {
          placeholder: 'Select dates...',
        },
      },
      warningTypes: {
        type: 'custom-multiselect',
        label: 'Warning types',
        options: WARNING_TYPE_OPTIONS,
        dropdownOptions: {
          placeholder: 'Select...',
          selectedOnTop: true,
          isClearable: true,
          style: { maxWidth: '250px', width: '250px' },
        },
      },
      ...getLocationFilterDefinitions({
        regionsOptions,
        countriesOptions,
        centresOptions,
        centreType: filtersValues.centreType,
      }),
    }),
    [regionsOptions, centresOptions, countriesOptions, filtersValues.centreType]
  );

  return (
    <FiltersBar
      value={filtersValues}
      filters={filtersDefinition}
      errors={errors}
      clearable
      expanded={true}
      onFiltersApply={onFiltersApply}
      onFiltersChange={onFiltersChange}
      defaultValues={initialFilterState}
    />
  );
};
